export enum StatusCode {
  'SuccessOK' = 200,
  "Created" = 201,
  'Unauthorized' = 401
}